import {Collection} from 'vue-mc';
import Config from "../config/config";
import userRoleModel  from "@/models/userRoleModel";

export default class userRoleCollection extends Collection {


  model() {
    return userRoleModel;
  }

  // Route configuration
  routes() {
    return {
      fetch: Config.publicApiURL + 'contacts/getroles?token=' + localStorage.getItem('jwt') + '&&client_portal=true'
    }
  }
}



// WEBPACK FOOTER //
// ./src/collections/userRoleCollection.js